import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import Dialer from "@/services/dialer/dialer";
import type { DialerPresence, SetDialerPresence } from "@/dtos/Dialer.dto";

export function useDialerPresence() {
  return useQuery({
    queryKey: ["dialerPresence"],
    queryFn: async (): Promise<DialerPresence> => {
      const result = await Dialer.getPresence();
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to load dialer presence");
      }
      return result.data.data;
    },
  });
}

export function useSetDialerPresence() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SetDialerPresence): Promise<DialerPresence> => {
      const result = await Dialer.setPresence(data);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to update dialer presence");
      }
      return result.data.data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["dialerPresence"], data);
    },
  });
}
